import queryString from 'query-string';

import type { BotGridItem, TGridFilterItem } from '~entities/grid';
import type { TGridFiltersQuery } from '~features/gridFilters';

export const GRID_PER_PAGE = 60;
export const SPECIAL_CARD = 1;

const apiBase = process.env.PUBLIC_API ?? 'https://api.ifriend.ai';

type GetPublicGridApiRequest = {
	query?: string;
	gender?: string;
	desireNames?: string;
	ageMin?: string;
	ageMax?: string;
	createdBy?: string;
	isSafe?: boolean;
	select?: number;
	omit?: number;
};

type GetPublicGridApiResponse = {
	botGrid: BotGridItem[];
	total: number;
};

type GetPublicGridFilters = TGridFilterItem[];

const DAY_HALF = 60 * 60 * 12;

export const getGrid = async ({
	page,
	slug,
	isSafeMode,
	params,
	request,
}: {
	page: number;
	slug?: string;
	isSafeMode: boolean;
	params?: TGridFiltersQuery;
	request?: RequestInit;
}) => {
	const countSpecial = isSafeMode ? 0 : SPECIAL_CARD;
	const omit = page > 1 ? (page - 1) * GRID_PER_PAGE - countSpecial : undefined;

	const query: GetPublicGridApiRequest = {
		desireNames: slug,
		isSafe: isSafeMode || undefined,
		query: params?.keyword,
		gender: params?.gender,
		ageMin: params?.minAge,
		ageMax: params?.maxAge,
		// TODO: Not in CS, probably no need
		// createdBy: params?.createdBy, // ? botTypesMode
		omit,
		select: page === 1 ? GRID_PER_PAGE - countSpecial : GRID_PER_PAGE,
	};

	const searchQuery = queryString.stringify(query);
	const response = await fetch(`${apiBase}/ai/grid/public?${searchQuery}`, {
		...request,
		next: {
			revalidate: DAY_HALF,
			...request?.next,
			tags: ['grid'],
		},
	});

	if (!response.ok) {
		throw new Error(`Error fetching grid: ${response.status}`);
	}

	return (await response.json()) as GetPublicGridApiResponse;
};

export const getGridFilters = async (params?: RequestInit) => {
	const response = await fetch(`${apiBase}/ai/chats/search/filters`, {
		...params,
		next: {
			revalidate: DAY_HALF,
			...params?.next,
			tags: ['grid-filters'],
		},
	});

	if (!response.ok) {
		throw new Error(`Error fetching grid filters: ${response.status}`);
	}

	const json = (await response.json()) as GetPublicGridFilters;

	return transformGridFilters(json);
};

export const transformGridFilters = (data: TGridFilterItem[]) => {
	const sorted = data.sort((left, right) => left.order - right.order);
	const result: TGridFilterItem[] = [];
	sorted.forEach((item) => {
		result.push({
			...item,
			category: item.filter.toLowerCase().replace(/[^a-z]/g, ''),
		});
	});
	return result;
};
